import { createFileRoute } from '@tanstack/react-router';

import { PortalPaymentsPage } from '@/modules/portal/pages/PortalPaymentsPage';

export const Route = createFileRoute('/portal/payments/')({
  component: PortalPaymentsPage,
});
